export default {
  en: {
    statisticsPage: {
      title: "Election Statistics",
      subtitle: "Comprehensive analytics and insights",
      electionType: "Election Type",
      presidential: "Presidential",
      parliamentary: "Parliamentary",
      senatorial: "Senatorial",
      regional: "Regional",
      council: "Council",
      pollingStations: "Polling Stations",
      registeredVoters: "Registered Voters",
      votesCast: "Votes Cast",
      voterTurnout: "Voter Turnout",
      validVotes: "Valid Votes",
      rejectedVotes: "Rejected Votes",
      ofTotal: "of total",
      resultsByCandidate: "Results by Candidate",
      noCandidateData: "No candidate data available",
      voteDistribution: "Vote Distribution",
      noVoteData: "No vote data available",
      votesByRegion: "Votes by Region",
      votes: "Votes",
      stations: "Stations",
      noRegionalData: "No regional data available",
      verificationStatus: "Results Verification Status",
      pending: "Pending",
      verified: "Verified",
      disputed: "Disputed"
    }
  },
  fr: {
    statisticsPage: {
      title: "Statistiques électorales",
      subtitle: "Analyses et informations complètes",
      electionType: "Type d'élection",
      presidential: "Présidentielle",
      parliamentary: "Législatives",
      senatorial: "Sénatoriales",
      regional: "Régionales",
      council: "Municipales",
      pollingStations: "Bureaux de vote",
      registeredVoters: "Électeurs inscrits",
      votesCast: "Votes exprimés",
      voterTurnout: "Taux de participation",
      validVotes: "Votes valides",
      rejectedVotes: "Votes rejetés",
      ofTotal: "du total",
      resultsByCandidate: "Résultats par candidat",
      noCandidateData: "Aucune donnée de candidat disponible",
      voteDistribution: "Répartition des votes",
      noVoteData: "Aucune donnée de vote disponible",
      votesByRegion: "Votes par région",
      votes: "Votes",
      stations: "Bureaux",
      noRegionalData: "Aucune donnée régionale disponible",
      verificationStatus: "Statut de vérification des résultats",
      pending: "En attente",
      verified: "Vérifiés",
      disputed: "Contestés"
    }
  }
};
